import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { OperatorService } from 'src/app/services/operator.service';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { faSearch, faPlus, faUserCog, faUser } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EliminaComponent } from 'src/app/popup/elimina/elimina.component';

@Component({
  selector: 'app-operator',
  templateUrl: './operator.component.html',
  styleUrls: ['./operator.component.css']
})
export class OperatorComponent implements OnInit {
  //tipe
  token: string;
  id: number;
  profile: number;
  selectedOP: number;
  _listFilter = '';
  selectedOPName: string;
  disponibility: number;
  cPassword: string;

  //any
  activeUser: any;
  tempUser: any;

  //Oggetto
  obj: any = {};
  objUpdate: any = {};
  selectedOperator: object = {};

  //Array
  profiles: Array<any> = [];
  operators: Array<any> = [];
  descrizione: Array<any> = [];
  filteredOperators: Array<any> = [];

  //Boolean
  del_update: boolean = false;
  vero: boolean = true;
  new: boolean = true;
  choose: boolean;
  vanish: boolean
  nome: boolean;
  cognome: boolean;
  email: boolean;
  username: boolean;
  pass: boolean;
  CPass: boolean;

  // Icone
  faUserCircle = faUserCircle;
  faSearch = faSearch;
  faUserCog = faUserCog;
  faUser = faUser;
  faPlus = faPlus;

  constructor(
    private operatorService: OperatorService,
    private globals: GlobalService,
    private modalService: NgbModal
  ) {
    this.filteredOperators = this.operators;
  }

  ngOnInit() {
    this.globals.checkPage(1);
    this.activeUser = this.globals.storagedUser;
    if (!this.token) {
      this.token = this.globals.getToken();
    }
    // this.getProfile();
    // this.getOperator();
    // this.getDisponibility();
    this.getInitPage();
  }

  get listFilter(): string {
    return this._listFilter;
  }

  set listFilter(value: string) {
    this._listFilter = value;
    this.filteredOperators = this.listFilter ? this.doFilter(this.listFilter) : this.operators;
  }

  reload() {
    this.svuotaSpan();
    this.tempUser = null;
    this.del_update = false;
    this.choose = false;
    this.vero = true;
    this.new = true;
    this.ngOnInit();
  }

  getInitPage() {
    this.operatorService.getInitPage(this.token).subscribe(
      res => {
        let varTemp
        if (res.error) {
          return this.globals.errorSniffer(res.error);
        } else {
          this.operators = res.operators;
          this.profiles = res.profiles;
          this.disponibility = res.disponibility;
          this.operators.forEach((op, k) => {
            if (op.user_id == this.activeUser.user_id) {
              varTemp = k;
            }
          });
          this.operators.splice(varTemp, 1)
          // Creo il campo descrizione per il campo di ricerca
          this.operators.forEach(operator => {
            operator.description = `${operator.username} ${operator.email} ${operator.name} ${operator.last_name} ${operator.name}`;
          })
          // Setto il filtro per la ricerca a campo vuoto
          this.listFilter = '';
          this.operators.forEach((op) => {
            this.profiles.forEach((prof) => {
              if (op.profile_id == prof.profile_id) {
                op.profile_name = prof.description;
              }
            })
          })
        }
      }
    )
  }

  getOperator() {
    if (this.tempUser) {
      var elementTwo = document.getElementById(this.tempUser);
      elementTwo.classList.remove("color-change")
    }

    this.operatorService.getOperator(this.token).subscribe(
      res => {
        let varTemp
        if (res.error) {
          return this.globals.errorSniffer(res.error);
        } else {
          this.operators = res;
          this.operators.forEach((op, k) => {
            if (op.user_id == this.activeUser.user_id) {
              varTemp = k;
            }
          });
          this.operators.splice(varTemp, 1)
          // Creo il campo descrizione per il campo di ricerca
          this.operators.forEach(operator => {
            operator.description = `${operator.username} ${operator.email} ${operator.name} ${operator.last_name} ${operator.name}`;
          })
          // Setto il filtro per la ricerca a campo vuoto
          this.listFilter = '';
          // this.operators.forEach((op, k) => {
          //   this.profiles.forEach(prof => {
          //     if (op.profile_id == prof.profile_id) {
          //       this.operators[k].push(prof.description)
          //       console.log(this.operators);

          //     }
          //   });
          // });
          this.operators.forEach((op) => {
            this.profiles.forEach((prof) => {
              if (op.profile_id == prof.profile_id) {
                op.profile_name = prof.description;
              }
            })
          })

        }
      },
      err => {
        console.error("Errore in getOperators", err);
      }
    )
  }

  changeStatus(profile) {
    if (this.tempUser) {
      var elementTwo = document.getElementById(this.tempUser);
      elementTwo.classList.remove("color-change")
    }

    this.newOperator()
    this.selectedOP = profile.profile_name;
    this.selectedOPName = profile.description;
  }

  

  showFormOp(op, eliminate) {

    this.svuotaSpan();

    if (this.tempUser) {
      var elementTwo = document.getElementById(this.tempUser);
      elementTwo.classList.remove("color-change")
    }

    if (!eliminate) {

      var element = document.getElementById(`operator${op.user_id}`);
      element.classList.add("color-change");

      this.tempUser = `operator${op.user_id}`;
    }


    this.vanish = true;

    if (eliminate == 'notcancel') {
      this.vanish = false;
    }
    this.getProfileName(op.profile_id);
    this.del_update = true;
    this.choose = true;
    this.new = false;
    this.selectedOperator = op;
    this.id = op.user_id;

  }

  newOperator() {
    this.svuotaSpan();
    this.del_update = false;
    this.new = true;
    this.selectedOperator = {}
    this.choose = true;
  }

  getProfile() {
    this.choose = false;
    this.operatorService.getOperatorProfile(this.token).subscribe(
      res => {
        this.profiles = res
      },
      err => {
        console.error("Errore in getProfile: ", err);

      })
  }

  svuotaSpan() {
    if (document.getElementById("opName")) {
      document.getElementById("opName").innerHTML = "";
    }
    if (document.getElementById("opLast_Name")) {
      document.getElementById("opLast_Name").innerHTML = "";
    }
    if (document.getElementById("opEmail")) {
      document.getElementById("opEmail").innerHTML = "";
    }
    if (document.getElementById("cusLast_Name")) {
      document.getElementById("cusLast_Name").innerHTML = ""
    }
    if (document.getElementById("opUsername")) {
      document.getElementById("opUsername").innerHTML = ""
    }
    if (document.getElementById("opPassword")) {
      document.getElementById("opPassword").innerHTML = ""
    }
    if (document.getElementById("opC_Password")) {
      document.getElementById("opC_Password").innerHTML = ""
    }
  }

  addOperator(selectedOperator, cPassword) {
    if (selectedOperator.name) {
      this.nome = true;
      document.getElementById("opName").innerHTML = "";
    } else {
      this.nome = false;
      document.getElementById("opName").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (selectedOperator.last_name) {
      this.cognome = true;
      document.getElementById("opLast_Name").innerHTML = "";
    } else {
      this.cognome = false;
      document.getElementById("opLast_Name").innerHTML = "↓ Il campo è obbligatorio";
    }
    if (selectedOperator.email) {
      this.email = true;
      document.getElementById("opEmail").innerHTML = "";
    } else {
      this.email = false;
      document.getElementById("opEmail").innerHTML = "↓ Il campo è obbligatorio";
    }
    if (selectedOperator.username) {
      this.username = true;
      document.getElementById("opUsername").innerHTML = "";
    } else {
      this.username = false;
      document.getElementById("opUsername").innerHTML = "↓ Il campo è obbligatorio";
    }
    if (selectedOperator.password) {
      this.pass = true;
      document.getElementById("opPassword").innerHTML = "";
    } else {
      this.pass = false;
      document.getElementById("opPassword").innerHTML = "↓ Il campo è obbligatorio";
    }
    if (selectedOperator.last_name) {
      this.CPass = true;
      document.getElementById("opC_Password").innerHTML = "";
    } else {
      this.CPass = false;
      document.getElementById("opC_Password").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (this.nome && this.cognome && this.email && this.username && this.pass && this.CPass) {
      this.profile = this.selectedOP;
      if (selectedOperator.password == cPassword) {
        this.obj = {
          user: this.selectedOperator,
          profile: this.profile
        }
        this.operatorService.addOperator(this.token, this.obj).subscribe(
          res => {
            this.getOperator();
            this.selectedOperator = {};
            this.cPassword = '';
            this.choose = true;
            this.reload();
          },
          err => {
            console.error("Errore in addOperator: ", err);
          }
        )
      } else {
        alert("Le password non corrispondono")
      }
    }
  }

  delProfile(user) {
    const modalRef = this.modalService.open(EliminaComponent, { backdrop: 'static', centered: true })
    modalRef.componentInstance.token = this.token;
    modalRef.componentInstance.userOperator = user;
    modalRef.result.then(result => {
      if (result != 'cancel') {
        // console.log(document.getElementById(`operator${result}`));
        let element = document.getElementById(`operator${result}`);
        this.tempUser = null;

        element.classList.remove("color-change")

        this.selectedOperator = {};
        this.choose = false;
        this.getOperator();
      }
    }, reason => {
    });


    // this.operatorService.deleteProfile(this.token, user_id).subscribe(
    //   res => {
    //     console.log("Profilo cancellato", res);
    //     this.selectedOperator = {};
    //     this.choose = false;
    //     this.getOperator();
    //   },
    //   err => {
    //     console.log("Errore in delOperator", err);
    //   }
    // )
  }

  updateProfile(username, email, name, last_name, user_id) {

    if (name) {
      this.nome = true;
      document.getElementById("opName").innerHTML = "";
    } else {
      this.nome = false;
      document.getElementById("opName").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (last_name) {
      this.cognome = true;
      document.getElementById("opLast_Name").innerHTML = "";
    } else {
      this.cognome = false;
      document.getElementById("opLast_Name").innerHTML = "↓ Il campo è obbligatorio";
    }
    if (email) {
      this.email = true;
      document.getElementById("opEmail").innerHTML = "";
    } else {
      this.email = false;
      document.getElementById("opEmail").innerHTML = "↓ Il campo è obbligatorio";
    }
    if (username) {
      this.username = true;
      document.getElementById("opUsername").innerHTML = "";
    } else {
      this.username = false;
      document.getElementById("opUsername").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (this.nome && this.cognome && this.email && this.username) {

      this.objUpdate = {
        username,
        email,
        name,
        last_name
      }

      this.operatorService.updateProfile(this.token, user_id, { user: this.objUpdate }).subscribe(
        res => {
          this.reload();
        },
        err => {
          console.error("Errore in updateUser", err);
        }
      )
    }
  }

  doFilter(filterBy: string) {
    filterBy = filterBy.toLocaleLowerCase();
    return this.operators.filter((operator) =>
      operator.description.toLocaleLowerCase().indexOf(filterBy) !== -1);
  }

  getProfileName(profile_id) {
    this.profiles.forEach((prof) => {
      if (prof.profile_id == profile_id) {
        return this.selectedOPName = prof.description;
      }
    })
  }

  getDisponibility() {
    this.operatorService.getDisponibility(this.token).subscribe(
      res => {
        this.disponibility = res.disponibility;
      },
      err => {
        console.error("Error on get disponibility", err);
      }
    )
  }

}